var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', [_c('el-header', {
    attrs: {
      "height": "auto"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-suffix": ":"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "查询时间"
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-right": "12px"
    },
    attrs: {
      "placeholder": "选择时间类型"
    },
    model: {
      value: (_vm.form.timeType),
      callback: function($$v) {
        _vm.$set(_vm.form, "timeType", $$v)
      },
      expression: "form.timeType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "上车时间"
    }
  }), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "到达时间"
    }
  })], 1), _c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.form.timeRange),
      callback: function($$v) {
        _vm.$set(_vm.form, "timeRange", $$v)
      },
      expression: "form.timeRange"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "乘客信息"
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-right": "12px",
      "width": "120px"
    },
    attrs: {
      "placeholder": "选择查询条件"
    },
    on: {
      "change": function($event) {
        _vm.form.passengerQueryValue = ''
      }
    },
    model: {
      value: (_vm.form.passengerQueryType),
      callback: function($$v) {
        _vm.$set(_vm.form, "passengerQueryType", $$v)
      },
      expression: "form.passengerQueryType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "手机号"
    }
  }), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "身份证号"
    }
  })], 1), _c('el-input', {
    staticStyle: {
      "width": "268px"
    },
    attrs: {
      "placeholder": _vm.setPlaceHolder1,
      "maxlength": _vm.maxLength1,
      "clearable": "clearable"
    },
    model: {
      value: (_vm.form.passengerQueryValue),
      callback: function($$v) {
        _vm.$set(_vm.form, "passengerQueryValue", $$v)
      },
      expression: "form.passengerQueryValue"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "司机信息"
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-right": "12px",
      "width": "120px"
    },
    attrs: {
      "placeholder": "选择查询条件"
    },
    on: {
      "change": function($event) {
        _vm.form.driverQueryValue = ''
      }
    },
    model: {
      value: (_vm.form.driverQueryType),
      callback: function($$v) {
        _vm.$set(_vm.form, "driverQueryType", $$v)
      },
      expression: "form.driverQueryType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "手机号"
    }
  }), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "身份证号"
    }
  })], 1), _c('el-input', {
    staticStyle: {
      "width": "268px"
    },
    attrs: {
      "placeholder": _vm.setPlaceHolder2,
      "maxlength": _vm.maxLength2,
      "clearable": "clearable"
    },
    model: {
      value: (_vm.form.driverQueryValue),
      callback: function($$v) {
        _vm.$set(_vm.form, "driverQueryValue", $$v)
      },
      expression: "form.driverQueryValue"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "位置信息"
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-right": "12px"
    },
    attrs: {
      "placeholder": "选择位置类型"
    },
    model: {
      value: (_vm.form.posType),
      callback: function($$v) {
        _vm.$set(_vm.form, "posType", $$v)
      },
      expression: "form.posType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": 1,
      "label": "上车位置"
    }
  }), _c('el-option', {
    attrs: {
      "value": 2,
      "label": "到达位置"
    }
  })], 1), _c('el-select', {
    staticStyle: {
      "margin-right": "12px",
      "width": "120px"
    },
    attrs: {
      "placeholder": "省份"
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.form.provinceCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "provinceCode", $$v)
      },
      expression: "form.provinceCode"
    }
  }, _vm._l((_vm.provinceList), function(province) {
    return _c('el-option', {
      key: province.provinceId,
      attrs: {
        "label": province.name,
        "value": province.provinceId
      }
    })
  })), _c('el-select', {
    staticStyle: {
      "margin-right": "12px",
      "width": "120px"
    },
    attrs: {
      "placeholder": "市"
    },
    model: {
      value: (_vm.form.cityCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "cityCode", $$v)
      },
      expression: "form.cityCode"
    }
  }, _vm._l((_vm.cityList), function(city) {
    return _c('el-option', {
      key: city.cityCode,
      attrs: {
        "label": city.name,
        "value": city.cityCode
      }
    })
  }))], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "车辆信息"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "172px"
    },
    attrs: {
      "placeholder": "请输入车辆牌照号",
      "maxlength": "8",
      "clearable": "clearable"
    },
    model: {
      value: (_vm.form.plateNumber),
      callback: function($$v) {
        _vm.$set(_vm.form, "plateNumber", $$v)
      },
      expression: "form.plateNumber"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)], 1), _c('el-main', [_c('grid', {
    ref: "grid",
    attrs: {
      "remoteMethod": _vm.getTableData,
      "layout": "prev, pager, next, jumper"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "乘客",
      "align": "center",
      "min-width": "150%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.passengerInfo.userName))]), _c('p', [_vm._v(_vm._s(scope.row.passengerInfo.idCard))]), _c('p', [_vm._v(_vm._s(scope.row.passengerInfo.mobile))])]
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "司机",
      "align": "center",
      "min-width": "150%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.driverInfo.userName))]), _c('p', [_vm._v(_vm._s(scope.row.driverInfo.idCard))]), _c('p', [_vm._v(_vm._s(scope.row.driverInfo.mobile))])]
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "上车时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("dateFormat")(scope.row.aboardTime)))])]
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "上车地址",
      "align": "center",
      "prop": "origin.longAddr"
    }
  }), _c('el-table-column', {
    attrs: {
      "label": "到达时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("dateFormat")(scope.row.arriveTime)))])]
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "到达地址",
      "align": "center",
      "prop": "destination.longAddr"
    }
  }), _c('el-table-column', {
    attrs: {
      "label": "牌照号",
      "align": "center",
      "prop": "plateNumber"
    }
  }), _c('el-table-column', {
    attrs: {
      "label": "车型信息",
      "align": "center",
      "prop": "carType"
    }
  }), _c('el-table-column', {
    attrs: {
      "label": "是否拼车",
      "align": "center",
      "prop": "poolStatus"
    }
  }), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function () { return _vm.clickDetail(scope.row); }
          }
        }, [_vm._v("详情")])]
      }
    }])
  })], 1)], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-09ef7fa3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09ef7fa3","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/hitch/index.vue
// module id = ZyAX
// module chunks = 1